import { render, staticRenderFns } from "./DownloadRow.vue?vue&type=template&id=faf9a7e8&scoped=true&"
import script from "./DownloadRow.vue?vue&type=script&lang=ts&"
export * from "./DownloadRow.vue?vue&type=script&lang=ts&"
import style0 from "./DownloadRow.vue?vue&type=style&index=0&id=faf9a7e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf9a7e8",
  null
  
)

export default component.exports